import script from "./PriceDetailsTableInternet.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceDetailsTableInternet.vue?vue&type=script&lang=ts&setup=true"

import "./PriceDetailsTableInternet.vue?vue&type=style&index=0&id=682d2a86&lang=scss"

const __exports__ = script;

export default __exports__